<!-- USed to display te versions in vault archives mails
component used in VaultArchiveDetail.vue
In (UI) Vault Search-> Open an mail-> click versions button
-->
<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="modalOpen"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: downloadFile,
      primaryButtonShow: versions.length,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Download'
    }"
    dataTestId="archive-versions-modal"
    @toggleModal="val => (modalOpen = val)"
  >
    <template slot="dialog_data">
      <v-card-text class="px-12 file-data-container" v-if="modalOpen">
        <loader v-if="loading" />
        <div v-if="!loading && !versions.length">
          <b>There is no versions for this.</b>
        </div>

        <div v-else>
          <VersionsTable
            :loading="loading"
            :modalOpen="modalOpen"
            :versions="versions"
            :versionsIds="versionsIds"
            :changeCheckState="changeCheckState"
            @select="select"
            @selectAll="selectAll"
            @getVersions="getVersions($event)"
          />
        </div>
      </v-card-text>
    </template>
  </x-dialog>
</template>
<script>
import EventBus from '@/EventBus';
import VaultDataService from '@/services/VaultDataService';
import DownloadService from '@/services/DownloadService';
import VersionsTable from '@/components/ArchiveSearch/VersionsTable';
export default {
  components: {
    VersionsTable
  },
  props: ['archiveId', 'sourceType'],
  data() {
    return {
      versionsIds: [],
      loading: false,
      // versions of currental archiveId
      versions: [],
      modalOpen: false,
      dialogTitle: 'versions',
      checkboxAll: false,
      changeCheckState: false
    };
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    EventBus.$on('OPEN_DIALOGUE', val => {
      this.modalOpen = val;
    });
  },
  watch: {
    modalOpen: async function() {
      if (this.modalOpen) {
        await this.getVersions({ pageSize: 5, pageNumber: 1 });
      } else {
        this.versionsIds = [];
      }
    }
  },
  methods: {
    // escape key listener to close the dialog when open
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.modalOpen) {
        this.closeDialog();
      }
    },
    // get versions data
    async getVersions({ pageSize, pageNumber }) {
      const type = this.$route.matched[0].path.substr(1);
      this.loading = true;
      this.versions = [];
      const response = await VaultDataService.getConnectorArchiveVersions({
        type,
        archiveId: this.archiveId,
        sourceType: this.sourceType,
        pageSize: pageSize,
        pageNumber: pageNumber
      });

      const parsedResponse = this.parseResponse(response);
      this.versions = parsedResponse[0]?.results;
      this.loading = false;
    },
    // to close dialog
    closeDialog() {
      this.versionsIds = [];
      this.checkboxAll = false;
      this.modalOpen = false;
    },
    /**
     * select all versions
     * @param {Boolean} status
     */
    selectAll(status) {
      this.versionsIds = [];
      if (status) {
        this.versionsIds = this.versions.map(version => version.archiveId);
      }
      this.changeCheckState = true;
    },
    // to download version file
    async downloadFile() {
      const type = this.$route.matched[0].path.substr(1);
      if (this.versionsIds.length) {
        this.loading = true;
        const response = await VaultDataService.donwloadMultipleArchive({
          type,
          archives: this.versionsIds.map(versionId => ({
            itemId: this.archiveId,
            sourceType: this.sourceType,
            version: this.versions.find(
              archive => archive.archiveId === versionId
            ).source.version
          }))
        });
        if (response) {
          await DownloadService.downloadZipFile(response);
          this.snackbar('success', 'Downloaded !');
          this.versionsIds = [];
          this.changeCheckState = false;
        } else {
          this.snackbar('error', this.$message.ERROR);
        }
        this.loading = false;
      } else {
        this.snackbar('info', this.$message.SELECT_FIELD);
      }
    },
    /**
     * to select a version
     * @param {Array} selected
     */
    select(selected) {
      this.versionsIds = selected;
    }
  }
};
</script>
<style>
.file-head {
  background-color: #1b2342;
  color: #fff;
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
.file-head input[type='checkbox'],
.file-head label {
  color: #fff !important;
}
.file-data {
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
</style>
